'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = ExperimentTreatments;

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var initialState = {
  isLoading: false,
  hasErrors: false,
  treatments: []
};

function ExperimentTreatments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.EXPERIMENT_TREATMENTS_REQUESTED:
      return _extends({}, state, { isLoading: true });
    case _ActionTypes.EXPERIMENT_TREATMENTS_RECEIVED:
      return {
        isLoading: false,
        hasErrors: false,
        treatments: payload.treatments
      };
    case _ActionTypes.EXPERIMENT_TREATMENTS_FAILED:
      return {
        isLoading: false,
        hasErrors: true
      };
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/ExperimentTreatments.js
// module id = 396
// module chunks = 3 4 5